package com.bikompanion.domain.analytics

/** Parameter values are `String` or `Long`, the two types every transport accepts unchanged. */
class AnalyticsEvent(
    val name: String,
    val parameters: Map<String, Any> = emptyMap(),
)
